import React from 'react';
import Select from 'react-select';
import {useSelector, useDispatch} from 'react-redux';
import {setLanguage} from '../../store/actions';

const Option = ({ innerProps, innerRef, data}) => {

return <button 
className="lang_custom_option" 
style={{textAlign: "center"}} 
ref={ innerRef } 
{ ...innerProps }>
	{ data.value.toUpperCase() }
	</button>;
}
const DropdownIndicator = (props) => {
	return<div className="custom_triangle_wrapper"><div className="custom_triangle"/></div>
};



const LangSelector = () => {
	const { language } = useSelector(store => store);
	const dispatch = useDispatch();

	const options = [
		{ value: 'ru', label: 'ru' },
		{ value: 'en', label: 'en' },
		{ value: 'es', label: 'es' }
	];
	return (
		<div style={ { zIndex: 950 } }>
			<Select
				options={ options }
				className='lang_select-container'
				classNamePrefix="lang_select"
				closeMenuOnSelect
				isSearchable={ false }
				components={ { Option, DropdownIndicator } }
				placeholder={false}
				value={{ value: language, label: language }}
				onChange={e => dispatch(setLanguage(e.value))}
				hideSelectedOptions
				// menuIsOpen
			/>
		</div>
	);
};

export default LangSelector;
